import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AuthserviceService} from '../content/pages-new-design/auth-page/login-page/authservice.service';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs/internal/Observable';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthserviceService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = this.authService.getToken();

    if (!req.headers.has('Content-Type') && !req.headers.has("cp-noContentType")) {
      req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
    }

    if (token) {
      req = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + token) });
    }
   return next.handle(req).pipe(
     map((event: HttpEvent<any>) => {
       return event;
     })
   );
  }
}
